import StepInfoAboutDamage from './stepInfoAboutDamage';

export default StepInfoAboutDamage;
